import { Component, DOCUMENT, Inject, OnInit, signal } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import {
  CcdlFooterComponent,
  PlatformNameEnum,
} from '@cpm-pr1618001/ng-design-lib';

enum Mode {
  DARK = 'dark',
  LIGHT = 'light',
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, CcdlFooterComponent],
})
export class AppComponent implements OnInit {
  window!: Window;
  public readonly Platform_Name_Enum = PlatformNameEnum;
  currentMode: string = 'dark';
  isRouting = signal(true);

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isRouting.set(true);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.isRouting.set(false);
      }
    });
  }

  ngOnInit() {
    // const deviceMode = window.matchMedia("(prefers-color-scheme: dark)");
    let initMode: Mode = this.getMode(); // this.modeStorage.get();
    // if (!initMode) {
    //   deviceMode.matches ? (initMode = Mode.DARK) : (initMode = Mode.LIGHT);
    // }
    this.updateCurrentMode(initMode);
  }

  getMode(): Mode {
    const deviceMode = window.matchMedia('(prefers-color-scheme: dark)');
    return deviceMode && deviceMode.matches && false ? Mode.DARK : Mode.LIGHT;
  }

  updateCurrentMode(initMode: Mode) {
    this.document.body.classList.add(initMode);
  }
}
